import { IComponentOptions } from 'angular';
import AccountManagerController from './account-manager.controller';

export const AccountManagerComponent: IComponentOptions = {
  template: require('./account-manager.html'),
  controller: AccountManagerController,
  bindings: {
    currentUser: '<',
  },
};

angular.module('nv.directives').component('nvAccountManagerWidget', AccountManagerComponent);
